import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-key-viewer',
  imports: [NgClass],
  templateUrl: './key-viewer.html',
  styleUrl: './key-viewer.scss',
})
export class KeyViewer {
  @Input() keyValue: string = '';

  isVisible: boolean = false;
  copied: boolean = false;

  toggleVisibility(): void {
    this.isVisible = !this.isVisible;
  }

  copyKey(): void {
    if (!this.keyValue) return;

    navigator.clipboard.writeText(this.keyValue).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 5000);
    });
  }

  get maskedKey(): string {
    if (!this.keyValue) return '';
    return '•'.repeat(this.keyValue.length);
  }
}
